import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import {
  ValidationErrorsModal,
  useValidationErrorsModal,
  setTouchedFromErrors
} from 'core/components/validation-errors-modal';
import useStyles from './switch-policy-modal/switch-policy-modal.styles';

// Shown when the agent picks another policy type while the form has unsaved edits.
// The switch reinitializes the form from the saved offer, so those edits would be lost silently.
// Keep it mounted and toggle `open`: the validation-errors modal it opens has to outlive this one.
const UnsavedOfferEditsModal = ({ open, onClose }) => {
  const classes = useStyles();
  const { resetForm, validateForm, setErrors, setTouched, handleSubmit } = useFormikContext();
  const { showValidationErrorsModal, setShowValidationErrorsModal } = useValidationErrorsModal();

  const onDiscard = () => {
    resetForm();
    onClose();
  };

  // Same steps as the footer's Update Offer button
  const onUpdate = async () => {
    onClose();
    const errors = await validateForm();
    if (Object.keys(errors).length) {
      setErrors(errors);
      setTouched(setTouchedFromErrors(errors), false);
      setShowValidationErrorsModal(true);
      return;
    }
    handleSubmit();
  };

  return (
    <>
      <BaseDialog open={open} onClose={onClose} className={classes.modal} size="md">
        <div className={classes.container}>
          <Label type="greenBig" className={classes.title}>
            Unsaved changes
          </Label>
          <Label type="modalBody">Update the offer to save your changes before switching policy types.</Label>
          <div className={classes.actions}>
            <Button onClick={onDiscard} variant="contained" color="secondary">
              Discard changes
            </Button>
            <Button onClick={onUpdate} variant="contained" color="primary">
              Update offer
            </Button>
          </div>
        </div>
      </BaseDialog>
      <ValidationErrorsModal open={showValidationErrorsModal} onClose={() => setShowValidationErrorsModal(false)} />
    </>
  );
};

UnsavedOfferEditsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default UnsavedOfferEditsModal;
